import { render, staticRenderFns } from "./ModalPaymentMethods.vue?vue&type=template&id=6f8338e4&scoped=true"
import script from "./ModalPaymentMethods.vue?vue&type=script&lang=js"
export * from "./ModalPaymentMethods.vue?vue&type=script&lang=js"
import style0 from "./ModalPaymentMethods.vue?vue&type=style&index=0&id=6f8338e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8338e4",
  null
  
)

export default component.exports